import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'searchFilter',
    standalone: false
})
export class SearchFilterPipe implements PipeTransform {
  transform(items: SearchItem[], searchText: string): SearchItem[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter((item: SearchItem) => {
      return item.name.toLowerCase().includes(searchText);
    });
  }
}

export interface SearchItem {
  name: string;
  id?: string;
}
